import React from 'react'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'
import { NavLink } from 'react-router-dom'
import track from 'react-tracking'
import { trackAccountNavigationClick } from '../../analytics'

const classNames = new BEMHelper('MyAccountNav')

const propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            to: PropTypes.string,
            href: PropTypes.string,
            exact: PropTypes.bool,
        })
    ),
    messages: PropTypes.shape({
        pages: PropTypes.object.isRequired,
    }).isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    tracking: PropTypes.object,
    enableStoreCredit: PropTypes.bool,
    storeCreditExclusionList: PropTypes.bool,
    locale: PropTypes.string,
}

const clickHandler = (handler, event, tracking, section) => {
    tracking && tracking.trackEvent(trackAccountNavigationClick(section))
    handler && handler(event)
}

function MyAccountNav(props) {
    const {
        links,
        messages,
        className,
        onClick,
        tracking,
        enableStoreCredit,
        storeCreditExclusionList,
        locale,
    } = props

    return (
        <ul className={classNames(null, null, className)}>
            {links.map((link) => {
                const { id, to, href, analyticsName, ...rest } = link
                return !!enableStoreCredit &&
                    storeCreditExclusionList.includes(locale.country) &&
                    id == 'credits' ? null : (
                    <li key={id} className={classNames('item', id)}>
                        {to ? (
                            <NavLink
                                onClick={(event) => clickHandler(onClick, event, tracking, analyticsName)}
                                to={to}
                                className={classNames('link')}
                                activeClassName={classNames('active')}
                                {...rest}
                            >
                                {messages.pages[id].title()}
                            </NavLink>
                        ) : (
                            <a
                                onClick={(event) => clickHandler(onClick, event, tracking, analyticsName)}
                                href={href}
                                className={classNames('link')}
                                {...rest}
                            >
                                {messages.pages[id].title()}
                            </a>
                        )}
                    </li>
                )
            })}
        </ul>
    )
}

MyAccountNav.propTypes = propTypes

export default track()(MyAccountNav)
